<template>
    <div class="card not-word-wrap mb-3">
        <div class="card-body">
            <Loading v-if="showLoading" />
            <div class="row">
                <div class="col-md-12">
                    <form class="row" v-on:submit.prevent="findCard">
                        <div class="col-md-4">
                            <div class="form-group">
                                <label>شماره کارت</label>
                                <input type="tel" class="form-control text-center" v-mask="'####-####-####-####'">
                            </div>
                        </div>
                        <div class="col-md-12">
                            <button class="btn btn-success">جستجو کارت</button>
                        </div>
                    </form>
                </div>
            </div>
            <hr v-if="transactions.length && searched">
            <div class="row mt-3" v-if="transactions.length && searched">
                <div class="col-12">
                    <table class="table table-bordered table-hover mb-0">
                        <thead>
                            <th>ردیف</th>
                            <th>تاریخ تراکنش</th>
                            <th>ساعت تراکنش</th>
                            <th>مبلغ</th>
                            <th>شناسه پیگیری</th>
                            <th>شناسه ارجاع</th>
                            <th>وضعیت</th>
                        </thead>
                        <tbody>
                            <tr v-for="(transaction,index) in transactions" :key="index">
                                <td>{{ index + 1 }}</td>
                                <td>{{ transaction.trxdate }}</td>
                                <td>{{ transaction.trxtime.slice(0,2) + ':' + transaction.trxtime.slice(2,4) + ':' + transaction.trxtime.slice(4,6) }}</td>
                                <td>{{ new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(transaction.amount) }} ریال</td>
                                <td>{{ transaction.paymentId }}</td>
                                <td>{{ transaction.rrn }}</td>
                                <td v-if="transaction.status"><span class="badge badge-success">موفق</span></td>
                                <td v-else><span class="badge badge-danger">ناموفق</span></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="row mt-3" v-if="!transactions.length && searched">
                <div class="col-12">
                    <div class="alert alert-info mb-0">
                        <p class="mb-0">اطلاعات کارت وارد شده یافت نشد</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Index',
    data(){
        return {
            showLoading: false,
            pan: '',
            transactions: [],
            searched: false,
            customerId: 0
        }
    },
    methods: {
        searchCustomer(){
            this.legalCustomerDetails = {};
            const postedData = {
                company: true,
                nationalId: this.nationalCode
            };
            this.showLoading = true;
            this.$api.post('Management/Group/SearchCustomer',postedData).then(({data}) => {
                if(data.status)
                    this.legalCustomerDetails = data.result;
                this.customerId = data.result.customerId;
                this.showLoading = false;
            }).finally(() => {
                this.showLoading = false;
            });
        },
        findCard(){
            this.showLoading = true;
            const postedData = {
                pan: this.pan
            };
            this.$api.post('CardTransaction/GetCardTransaction',postedData).then(({data}) => {
                if(data.status)
                    this.transactions = data.result.list;
            }).finally(() => {
                this.searched = true;
                this.showLoading = false;
            });
        }
    }
}
</script>